import Header from "./Header";

// Legal pages reuse the main header in its minimal variant (logo + language switch only).
const PrivacyHeader = () => <Header minimal />;

export default PrivacyHeader;
